import ReactOnRails from 'react-on-rails';

import ImageViewer from '../bundles/ImageViewer';
import SyntaxExample from '../bundles/SyntaxExample';

const Rails = require('rails-ujs');
Rails.start();

ReactOnRails.register({
  ImageViewer,
  SyntaxExample,
});

const initExpandableImages = () => {
  const triggers = document.querySelectorAll('[data-expandable-image]');
  if (!triggers.length) return;

  const overlays = new Set();

  const closeAll = () => {
    overlays.forEach((overlay) => {
      overlay.classList.remove('docs-image-overlay--visible');
    });
    document.body.classList.remove('docs-image-overlay--open');
  };

  triggers.forEach((trigger) => {
    if (trigger.hasAttribute('data-expandable-initialized')) return;

    const targetSelector = trigger.getAttribute('data-expandable-target');
    let overlay = null;

    if (targetSelector) {
      try {
        overlay = document.querySelector(targetSelector);
      } catch (e) {
        // Ignore invalid selectors and fall back to sibling lookup
      }
    }

    if (!overlay) {
      overlay = trigger.nextElementSibling;
    }

    if (!overlay || !overlay.classList.contains('docs-image-overlay')) return;

    trigger.setAttribute('data-expandable-initialized', 'true');

    // Move overlay to body so it isn't clipped by parent overflow/transform
    if (overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }

    overlays.add(overlay);

    const open = (event) => {
      if (event) event.preventDefault();
      overlay.classList.add('docs-image-overlay--visible');
      document.body.classList.add('docs-image-overlay--open');
      // Trigger lazy load of overlay image now that it's visible
      const overlayImg = overlay.querySelector('.docs-image-overlay__image');
      if (overlayImg && typeof window.lazysizes !== 'undefined') {
        window.lazysizes.loadUnveil(overlayImg);
      }
    };

    const close = (event) => {
      if (event) event.preventDefault();
      overlay.classList.remove('docs-image-overlay--visible');
      if (![...overlays].some((o) => o.classList.contains('docs-image-overlay--visible'))) {
        document.body.classList.remove('docs-image-overlay--open');
      }
    };

    trigger.addEventListener('click', open);

    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) {
        close(event);
      }
    });

    const closeButton = overlay.querySelector('[data-expandable-close]');
    if (closeButton) {
      closeButton.addEventListener('click', close);
    }

    const overlayImage = overlay.querySelector('.docs-image-overlay__image');
    if (overlayImage) {
      overlayImage.addEventListener('click', close);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAll();
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initExpandableImages);
} else {
  initExpandableImages();
}

if (typeof Turbo !== 'undefined') {
  document.addEventListener('turbo:load', initExpandableImages);
} else if (typeof Turbolinks !== 'undefined') {
  document.addEventListener('turbolinks:load', initExpandableImages);
}
